import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { ravelComponentPath } from '../../../../common/RavelComponentPath.js';

export class RavelCgolGrid extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            position: absolute;
            cursor: pointer;
            user-select: none;
            display: grid;
            justify-content: center;
            align-items: center;
        }
        .cell img {
            width: 16px;
            height: 16px;
        }
        .visible {
            visibility: visible;
        }
        .not-visible {
            visibility: hidden; 
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="sensor">
        <div id="container">
        </div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 
            'images', 'rows', 'cols', 'coverage', 'angle',
            'signals', 'signal-out'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.sensor = this.shadowRoot.querySelector('#sensor');
        this.signals = [];
        this.x = 0;
        this.y = 0;
        this.rows = 4;
        this.cols = 5;
        this.width = 50;
        this.height = 50;
        this.pixelSize = 20;
        this.images = ['/images/blue-flower.png'];
        this.coverage = 30;
        this.angle = 0;
        this.playing = false;
        this.cells = [];  // 2D array for cell states
        this.count = [];  // 2D array for neighbor counts

    }
  
    setup = () => {
        this.observedMessages = [`${this.id}`];
        this.subscribe(this.observedMessages);
        this.subscribe(this.signals);  

        this.container.style.display = 'grid';
        this.container.style.top = `${this.y}px`;
        this.container.style.left = `${this.x}px`;
        this.container.style.transform = `rotate(${this.angle}deg)`;
        this.container.style.gridTemplateRows = `repeat(${this.rows}, 1fr)`;
        this.container.style.gridTemplateColumns = `repeat(${this.cols}, 1fr)`;

        this.setupField();

        this.broadcastMessage('register-sensor', this.id, this.container);
        // this.broadcastMessage('register-sensor', this.id, { x: this.x + this.w/2, y: this.y + this.h/2, w: this.w, h: this.height });

        this.timer = setInterval(this.processFrame, 100);

        this.container.addEventListener('click', this.handleEvent);
    }

    handleClick = (e) => {
        e.preventDefault();
    }

    handleEvent = (e) => {
        if (!this.playing) this.playing = true;
        if ((e.target.id.includes('cell')) && !(e.target.id.includes('img'))) {
            this.shadowRoot.querySelector(`#${e.target.id}`).classList.toggle('visible', true);
            let index = 0;
            try {
                index = parseInt(e.target.id.replace('cell-', ''));
            } catch(e) {}
            console.log(index);
            console.log(this.shadowRoot.querySelector(`#${e.target.id}`));
        }
    }

    setupField = () => {
        for (let i = 0; i < this.rows; i++) {
            this.cells[i] = [];
            this.count[i] = [];

            for (let j = 0; j < this.cols; j++) {
                const index = (this.cols * i) + j;  // still useful for DOM IDs
                const cell = document.createElement('div');
                cell.classList.add('cell');
                const cellImg = document.createElement('img');
                cellImg.src = this.getRandomImage();
                cell.id = `cell-${index}`;
                cellImg.id = `cell-img-${index}`;

                const isAlive = Math.floor(Math.random() * 100) < this.coverage;

                this.cells[i][j] = isAlive;
                this.count[i][j] = 0;

                cellImg.classList.add(isAlive ? 'visible' : 'not-visible');
                cell.appendChild(cellImg);
                this.container.appendChild(cell);
            }
        }
    };
    
    processFrame = () => {
        if (!this.playing) return;

        // Step 1: Count neighbors based on *current* state
        for (let i = 0; i < this.rows; i++) {
            for (let j = 0; j < this.cols; j++) {
            this.count[i][j] = this.getNeighborCount(i, j);
            }
        }

        // Step 2: Prepare next generation
        const nextCells = [];

        for (let i = 0; i < this.rows; i++) {
            nextCells[i] = [];

            for (let j = 0; j < this.cols; j++) {
            const alive = this.cells[i][j];
            const neighbors = this.count[i][j];
            const index = i * this.cols + j;
            const cellElement = this.shadowRoot.querySelector(`#cell-img-${index}`);

            let nextState = alive;

            if (!alive && neighbors === 3) {
                nextState = true;
            } else if (alive && (neighbors < 2 || neighbors > 3)) {
                nextState = false;
            }

            nextCells[i][j] = nextState;

            if (cellElement) {
                cellElement.classList.toggle('visible', nextState);
                cellElement.classList.toggle('not-visible', !nextState);
            }
            }
        }

        // Step 3: Commit next generation
        this.cells = nextCells;
    };

    getRandomImage = () => {
        let index = Math.floor(Math.random() * this.images.length);
        return `${ravelComponentPath}/${this.images[index]}`;
    }

    getNeighborCount = (row, col) => {
        let count = 0;
        const directions = [
            [-1, 0],  // top
            [-1, -1], // top-left
            [-1, 1],  // top-right
            [0, -1],  // left
            [0, 1],   // right
            [1, -1],  // bottom-left
            [1, 1],   // bottom-right
            [1, 0]    // bottom
        ];

        for (let [dr, dc] of directions) {
            const r = row + dr;
            const c = col + dc;
            if (r >= 0 && r < this.rows && c >= 0 && c < this.cols) {
                if (this.cells[r][c]) count++;
            }
        }

        return count;
    }

    teardown = () => {
        this.unsubscribe(this.signals);
        this.broadcastMessage('register-sensor', this.id);
        if (!this.noClick) {
            this.removeEventListener('pointerdown', this.handleClick);
        }
        this.removeEventListener(`${this.id}`, this.handleEvent);
    }
    
    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'x') {
            this.x = Number(newValue);
        }
        if (name === 'y') {
            this.y = Number(newValue);
        }
        if (name === 'images') {
            this.images = newValue.split(',');
            console.log(this.images.length);
        }
        if (name === 'width') {
            this.width = Number(newValue);
        }
        if (name === 'height') {
            this.height = Number(newValue);
        }
        if (name === 'angle') {
            this.angle = parseInt(newValue, 10);
        }
        if (name === 'rows') {
            this.rows = parseInt(newValue, 10);
        }
        if (name === 'cols') {
            this.cols = parseInt(newValue, 10);
        }
        if (name === 'coverage') {
            this.coverage = parseInt(newValue, 10);
        }
        if (name === 'signals') {
            this.signals = newValue.split(',');
        }
        if (name === 'signal-out') {
            this.signalOut = newValue;
        }
        if (name === 'no-click') {
            this.noClick = true;
        }
    }

    map = (val, in_min, in_max, out_min, out_max) => {
        return (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
    }
}
